// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyB3N0QSmznr8AUWMVB5lQg7s0cRAkTVKLM",
    authDomain: "firmas-2020.firebaseapp.com",
    databaseURL: "https://firmas-2020.firebaseio.com",
    projectId: "firmas-2020",
    storageBucket: "firmas-2020.appspot.com",
    messagingSenderId: "683432656873",
    appId: "1:683432656873:web:b17bc04dd5ba56cd9a9578",
    measurementId: "G-3V4GNBJ41Q"
  }



};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
